import React, { useState, useEffect } from "react";
import "./inner_banner.css";
import { SocialIcon } from "react-social-icons";
import { FaQuestion } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import EnquiryForm from "../../page_content/enquiry_form/EnquiryForm";

const InnerBanner = ({ bgImage, title, subtitle }) => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState([]);
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);

  useEffect(() => {
    setCurrent([{
      url: "https://api.whatsapp.com/send/?phone=918308010405&text&type=phone_number&app_absent=0",
      network: "whatsapp",
      bgColor: "#25D366",
    }]);
  }, []);

  return (
    <div className="inner-bnr" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="inner-bnr-overlay">
        <h2 className="inner-bnr-title">{title}</h2>
        {subtitle && <h3 className="inner-bnr-subtitle">{subtitle}</h3>}

        <div className="inner-bnr-enquiry">
          <Link to="/admissions/admission-2026" className="bnr-btn">
            Apply Now
          </Link>

          <div className="enquiry-button-container">
            <button
              className="bnr-btn"
              onClick={() => setShowEnquiryForm(prev => !prev)}
            >
              Enquiry Now
            </button>

            {showEnquiryForm && (
              <div className="enquiry-form-slide">
                <div className="form-header">
                  <h3>Quick Enquiry</h3>
                  <p>Get information about our courses</p>
                  <button
                    className="enquiry-close-btn"
                    onClick={() => setShowEnquiryForm(false)}
                  >
                    <IoClose size={22} />
                  </button>
                </div>
                <EnquiryForm isSticky={true} />
              </div>
            )}
          </div>

          <div className="social-icons">
            {current.map((link, index) => (
              <SocialIcon
                key={index}
                className="bnr-social-icons fade-in"
                url={link.url}
                network={link.network}
                bgColor={link.bgColor}
              />
            ))}
            <div
              className="fa-question-wrapper"
              style={{ marginTop: "10px", cursor: "pointer" }}
              onClick={() => navigate("/admissions/admission-faq")}
            >
              <FaQuestion className="faq-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InnerBanner;
